export default __webpack_public_path__ + "static/2059-6e3d64fe5ec41e30e2330e1cf34de067.gif";